import axios from "axios";
import {
    ACCESS_TOKEN,
    DELETE_GLOBAL_CONFIG_URL,
    GET_GLOBAL_CONFIG_BY_ID,
    GET_GLOBAL_CONFIG_LIST,
    POST_GLOBAL_CONFIG_URL,
    UPDATE_GLOBAL_CONFIG_URL
} from "../helpers/Constant";

export default class GlobalConfigService {

    static getGlobalConfigList(params) {
        return axios.get(GET_GLOBAL_CONFIG_LIST, {...GlobalConfigService.getAuthHeader(), params});
    }

    static addGlobalConfig(data) {
        return axios.post(POST_GLOBAL_CONFIG_URL, data, GlobalConfigService.getAuthHeader());
    }

    static getGlobalConfigById(id) {
        return axios.get(`${GET_GLOBAL_CONFIG_BY_ID}/${id}`, GlobalConfigService.getAuthHeader());
    }

    static deleteGlobalConfig(id) {
        return axios.delete(`${DELETE_GLOBAL_CONFIG_URL}/${id}`, GlobalConfigService.getAuthHeader());
    }

    static editGlobalConfig(id, data) {
        return axios.put(`${UPDATE_GLOBAL_CONFIG_URL}/${id}`, data, GlobalConfigService.getAuthHeader());
    }

    static getAuthHeader = () => {
        const accessToken = localStorage.getItem(ACCESS_TOKEN);
        return {headers: {"x-auth-token": accessToken}};
    }

}